<template>
    <nuxt-layout name="main-big" :dark="true" :favorite="true">
        <!-- * 基因搜索窗口 -->
        <search-gene-modal ref="modal" trigger="none" @change="methods.next" />

        <div :class="css.container" class="container">
            <!-- * 头部 -->
            <div :class="css.header" class="color-1 font-bold">
                <div :class="css.name" class="font-variable">{{ $t("SequenceViewer") }}</div>
                <div :class="css.descript" class="font-variable">{{ $t("SequenceViewerVice") }}</div>
            </div>

            <ToolSearch
                size="large"
                :class="css.input"
                ref="search"
                v-model="keyword"
                :placeholder="$t('Placeholder.SearchGeneOrID', 2)"
                @search="modal?.open(keyword)" />

            <div :class="css.introduce">
                {{ $t("SequenceViewerIntroduction") }}
            </div>
        </div>
    </nuxt-layout>
</template>

<script lang="ts" setup>
//* 公共组件
import { SearchGeneModal } from "@/components/windows";
import { ToolSearch } from "@/components/controls";
//* 组件属性
import { useComposable } from "./src/composable";
//* 样式
import css from "./style/index.module.less";

//* 组合函数
const { refs, nodes, methods } = useComposable();
const { keyword } = refs;
const { modal } = nodes;
</script>
